import ImgStep from '../assets/images/step.png';
import ImgFlag from '../assets/images/flag.png';
import ImgBoom from '../assets/images/boom.png';

export const MatrixTypes = [
  { column: 2, row: 3, type: '2x3', enumType: '_2x3'},
  { column: 3, row: 6, type: '3x6', enumType: '_3x6' },
  { column: 4, row: 9, type: '4x9', enumType: '_4x9' },
  { column: 5, row: 12, type: '5x12', enumType: '_5x12' },
  { column: 6, row: 15, type: '6x15', enumType: '_6x15' },
]

export const FieldImageType = [
  {src: null, type: ''},
  {src: ImgStep, type: 'step'},
  {src: ImgBoom, type: 'boom'},
  {src: ImgFlag, type: 'flag'},
]

export const ImageEnums = {
  unopened: 0,
  step: 1,
  boom: 2,
  flag: 3
}

export const FieldBorderStyle = {
  none: 0,
  current: 1,
  win: 2,
  lose: 3
}